import Clarity from '@microsoft/clarity';
import { AnalyticsEvent, Tracker, DatadogService } from '@water-web/view';
import { CustomerModel } from '@water-web/repository';
import * as Sentry from '@sentry/react';

import { config } from '@app/config';

const clarityProjectId = config.analytics.clarity.projectId;

export class ClarityTracker implements Tracker {
  constructor() {
    Clarity.init(clarityProjectId);
  }

  getName(): string {
    return 'ClarityTracker';
  }

  track(event: AnalyticsEvent): void {
    Clarity.event(event);
  }

  trackCustomerInfo(customer: CustomerModel): void {
    // Only identify customer if they are logged in
    const userId = customer.getUserId();
    if (userId) {
      const email = customer.getEmail();
      const firstName = customer.getFirstName();
      const lastName = customer.getLastName();
      const friendlyName = [firstName, lastName].filter(Boolean).join(' ') || email;

      Clarity.identify(userId, undefined, undefined, friendlyName);
    }
  }

  identify(userId: string): void {
    if (userId) {
      Clarity.identify(userId);
    }
  }

  static generateSessionUrl(): void {
    if (typeof window === 'undefined') return;

    const getCookieValue = (cookieName: string): string | undefined => {
      const cookies = document.cookie ? document.cookie.split('; ') : [];
      const cookie = cookies.find((c) => c.split('=')[0] === cookieName);
      if (cookie) {
        return decodeURIComponent(cookie.split('=')[1] || '');
      }
      return undefined;
    };

    const splitByPreferredDelimiter = (value: string): string[] => {
      if (value.includes('^')) {
        return value.split('^');
      }
      return value.split('|');
    };

    const sessionId = getCookieValue('_clsk');
    const userId = getCookieValue('_clck');

    if (sessionId && userId) {
      const sessionIdNewValue = splitByPreferredDelimiter(sessionId)[0];
      const userIdNewValue = splitByPreferredDelimiter(userId)[0];

      const clarityURL = `https://clarity.microsoft.com/player/${clarityProjectId}/${userIdNewValue}/${sessionIdNewValue}`;
      DatadogService.addClaritySession({
        sessionId: sessionIdNewValue,
        userId: userIdNewValue,
        sessionUrl: clarityURL,
      });
      Sentry.setContext('clarity', { sessionUrl: clarityURL, sessionId: sessionIdNewValue, userId: userIdNewValue });
    }
  }
}
